import { namespace } from 'vuex-class';
import type { BindingHelpers } from 'vuex-class/lib/bindings';
import type { UniversalLinkState } from './universal-link.types';

export const UniversalLink: BindingHelpers = namespace('universalLink');

export function getDefaultState(): UniversalLinkState {
  return {
    loading: false,
    loaded: false,
    loadingError: false,
    verifyLinkResponse: null,
    loadingRedirectURL: false,
    redirectURL: null,
    redirectURLError: null,
  };
}
